export default __webpack_public_path__ + "media/verification/title_locale_tr-ce0197f1.png";